import { Component, input } from '@angular/core';
import { BootstrapIcon, Severity } from '@shared/types/dev';

@Component({
  selector: 'idel-rounded-button',
  templateUrl: './rounded-button.component.html',
  styleUrl: './rounded-button.component.scss',
})
export class RoundedButtonComponent {
  public readonly icon = input.required<BootstrapIcon>();
  public readonly severity = input<Severity>('secondary');
  public readonly outlined = input<boolean>(false);
  public readonly tooltip = input<string>('');
  public readonly tooltipPosition = input<'left' | 'right' | 'top' | 'bottom'>('right');
  public readonly disabled = input<boolean>(false);
  public readonly loading = input<boolean>(false);
  public readonly hoverable = input<boolean>(true);

  public get backgroundColorClassname(): string {
    switch (this.severity()) {
      case 'primary':
        return 'rounded-button--primary';
      case 'secondary':
        return 'rounded-button--secondary';
      case 'success':
        return 'rounded-button--success';
      case 'danger':
        return 'rounded-button--danger';
      case 'warning':
        return 'rounded-button--warning';
      default:
        return 'rounded-button--secondary';
    }
  }
}
